import React from 'react';

const Integrations = () => {
  return (
    <div className="flex-1 flex flex-col min-h-0 bg-white p-6 items-center justify-center border border-[#E5E7EB] rounded-lg shadow-sm">
      <h2 className="text-[#171717] font-outfit text-xl font-semibold mb-2">Integrations</h2>
      <p className="text-[#52525B] font-outfit text-[14px]">Connect DocuSensa with Google Drive, Salesforce, and other tools.</p>
    </div>
  );
};

export default Integrations;
